import {
  getAdvertmentList,
  createAdvertment,
  updateAdvertment,
  deleteAdvertment,
  checkAdvertCanModify,
  queryDefaultAdvertmentList,
  createDefaultAdvertment,
  updateDefaultAdvertment,
  queryShopAdvert,
  addShopAdvert,
  updateShopAdvert,
  deleteShopAdvert
} from '@/api/sys.advertment'

export default {
  namespaced: true,
  actions: {
    /**
     * 分页查询
     */
    getAdvertmentList ({
      dispatch
    }, {
      vm,
      pageable
    }) {
      return getAdvertmentList(pageable)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    /**
     * @description 新增广告
     * @param {Object} param context
     * @param {Object} param vm {Object} vue 实例
     * @param {Object} param data {Object} 数据
     */
    createAdvertment ({
      dispatch
    }, {
      vm,
      advert
    }) {
      // 开始请求
      return createAdvertment(advert)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    updateAdvertment ({
      dispatch
    }, {
      vm,
      advert
    }) {
      // 开始请求
      return updateAdvertment(advert)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    deleteAdvertment ({
      dispatch
    }, {
      vm,
      id
    }) {
      // 开始请求
      return deleteAdvertment(id)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    checkAdvertCanModify ({
      dispatch
    }, {
      vm,
      data
    }) {
      // 开始请求
      return checkAdvertCanModify(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    /**
     * 分页查询默认广告
     */
    queryDefaultAdvertmentList ({
      dispatch
    }, {
      vm,
      pageable
    }) {
      return queryDefaultAdvertmentList(pageable)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    /**
       * 添加默认广告
       * @param {} param0
       * @param {*} param1
       * @returns
       */
    createDefaultAdvertment ({
      dispatch
    }, {
      vm,
      advert
    }) {
      // 开始请求
      return createDefaultAdvertment(advert)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    updateDefaultAdvertment ({
      dispatch
    }, {
      vm,
      advert
    }) {
      // 开始请求
      return updateDefaultAdvertment(advert)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    queryShopAdvert ({
      dispatch
    }, {
      vm,
      data
    }) {
      // 开始请求
      return queryShopAdvert(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    addShopAdvert ({
      dispatch
    }, {
      vm,
      data
    }) {
      // 开始请求
      return addShopAdvert(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    updateShopAdvert ({
      dispatch
    }, {
      vm,
      data
    }) {
      // 开始请求
      return updateShopAdvert(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    deleteShopAdvert ({
      dispatch
    }, {
      vm,
      data
    }) {
      // 开始请求
      return deleteShopAdvert(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    }

  }
}
